import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Avatar, Grid, Stack, Tab, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import {
  ExpRegSoloNumeros,
  ExpRegSoloNumerosPassport,
  dateformat,
  tryCatchHelper,
} from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import {
  GenerosField,
  LoadingWidget,
  TiposDniField,
} from '../../../../widgets';
import TiposParentescosField from '../../../../widgets/fields/TiposParentescosField';
import { FechaField } from '../../../accesos/components/FechaField';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import {
  FAMILY_CONST,
  STUDENT_CONST,
  TEACHER_CONST,
} from '../../../auth/login/LoginReducer';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { getSearchUsuariosService } from '../../../usuario/usuarios/UsuariosService';
import CardEstudianteComponent from '../../boletines/components/CardEstudiante';
import { allEstudiantesService } from '../../estudiantes/EstudiantesService';
import {
  asignarFamiliaresAction,
  saveFamiliaresAction,
} from '../FamiliaresAction';

let intervalSearch = null;
let intervalSearchUser = null;
const FormFamiliarComponent = ({ setOpenModalForm = false }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const usuariosStore = Redux.useSelector((state) => state.usuarios);
  const familiaresStore = Redux.useSelector((state) => state.familiares);

  const activo = usuariosStore.activo;

  const initData = {
    tipoDni: 'V',
    dni: '',
    pnombre: '',
    snombre: '',
    papellido: '',
    sapellido: '',
    fechaNacimiento: '',
    genero: 'M',
    correo: '',
    password: '',
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    dni: false,
    pnombre: false,
    papellido: false,
    fechaNacimiento: false,
    correo: false,
    password: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  const [loadingSearch, setLoadingSearch] = React.useState(false);
  const [textSearchEstudiante, setTextSearchEstudiante] = React.useState('');
  const [selectEstudiantes, setSelectEstudiantes] = React.useState([]);
  const [estudiantes, setEstudiantes] = React.useState([]);

  const [loadingSearchUsuario, setLoadingSearchUsuario] = React.useState(false);
  const [userSearch, setUserSearch] = React.useState(null);

  const [tab, setValue] = React.useState('1');

  const handleTabs = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    if (!activo) return;
    const { correo, perfil } = activo;
    let values = {
      correo,
      ...perfil,
    };
    setTimeout(() => setData(values), 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];

    if (activo) {
      delete dataError.password;
    }

    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (selectEstudiantes.length === 0) {
      notify('Falta agregar al menos un estudiante', { warning: true });
      return;
    }

    const estudiantes = [];
    selectEstudiantes.forEach((el) => {
      const { parentesco, estudiante } = el;
      estudiantes.push({
        parentesco,
        idEstudiante: estudiante.usuario.id,
      });
    });

    if (userSearch) {
      setLoadingSave(true);
      const res = await asignarFamiliaresAction(
        { dispatch, notify },
        {
          idEntidad: entidadesStore.activo.id,
          idFamiliar: userSearch.id,
          estudiantes,
        },
        familiaresStore.params,
      );
      if (res) {
        setUserSearch(null);
        setOpenModalForm(false);
      }
      setLoadingSave(false);
      return;
    }

    if (_validDataForm()) {
      setLoadingSave(true);
      const {
        tipoDni,
        dni,
        pnombre,
        snombre,
        papellido,
        sapellido,
        genero,
        fechaNacimiento,
        correo,
        password,
      } = data;
      const dataApi = {
        correo,
        password,
        tipoDni,
        dni,
        pnombre,
        snombre,
        papellido,
        sapellido,
        genero,
        fechaNacimiento,
        estudiantes,
        idEntidad: entidadesStore.activo.id,
      };
      let res = await saveFamiliaresAction(
        { dispatch, notify },
        dataApi,
        familiaresStore.params,
      );

      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  React.useEffect(() => {
    if (!userSearch && !activo && (data.dni || data.dni !== '')) {
      _handleSetDataField(CONST.password.name, data.dni);
    }

    if (data.dni.length > 6) {
      searchTextData(data.dni);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.dni]);

  React.useEffect(() => {
    if (userSearch) {
      const { correo, perfil } = userSearch;
      let values = {
        correo,
        ...perfil,
      };

      const data = {};
      Object.keys(initData).map((key) => (data[key] = values[key]));

      setTimeout(() => setData(data), 300);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSearch]);

  async function searchTextData(q) {
    clearTimeout(intervalSearchUser);
    intervalSearchUser = setTimeout(async () => {
      setLoadingSearchUsuario(true);
      await getSearchUsuariosService({ q })
        .then((res) => {
          if (
            res.data.data.length > 0 &&
            [FAMILY_CONST, STUDENT_CONST, TEACHER_CONST].includes(
              res.data?.data[0]?.rol,
            )
          ) {
            setUserSearch(res.data.data[0]);
          } else {
            setUserSearch(null);
            const dni = data.dni;
            setData({ ...initData, dni });
          }
          setLoadingSearchUsuario(false);
        })
        .catch((e) => {
          setUserSearch(null);
          tryCatchHelper({ e, notify });
        });
    }, 1000);
  }

  const selectTipoDni = (
    <TiposDniField
      value={data.tipoDni}
      required
      disabled={userSearch}
      onChange={(e) =>
        userSearch
          ? false
          : _handleSetDataField(CONST.tipoDni.name, e.target.value)
      }
    />
  );

  const selectGenero = (
    <GenerosField
      value={data.genero}
      onChange={(e) =>
        userSearch
          ? false
          : _handleSetDataField(CONST.genero.name, e.target.value)
      }
      required
      disabled={userSearch}
    />
  );

  const familiarWidget = (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        {selectTipoDni}
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          size="small"
          id={CONST.dni.name}
          required
          label={data.dniEscolar ? CONST.dniEscolar.family : CONST.dni.label}
          value={data.dni}
          onChange={(e) => {
            let text = e.target.value;

            if (data.tipoDni.toString() === 'V') {
              text = text.replace(/[^0-9]/g, '');

              if (text.length === 9) return;
            }

            let v = false;
            if (data.tipoDni.toString() === 'P') {
              if (text.length === 20) return;
              v = text.match(ExpRegSoloNumerosPassport) != null;
            } else {
              v = text.match(ExpRegSoloNumeros) != null;
            }

            if (text === '') {
              _handleSetDataField(CONST.dni.name, e.target.value);
              return;
            }

            if (!v) text = text.slice(0, -1);

            _handleSetDataField(CONST.dni.name, text);
          }}
          helperText={dataError.dni ? validMessage.required : null}
          error={dataError.dni}
        />
        {loadingSearchUsuario && (
          <LoadingWidget isLoading={loadingSearchUsuario} />
        )}
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          size="small"
          id={CONST.pnombre.name}
          required
          disabled={userSearch}
          label={CONST.pnombre.label}
          value={data.pnombre}
          onChange={(e) =>
            userSearch
              ? false
              : _handleSetDataField(
                  CONST.pnombre.name,
                  e.target.value.toUpperCase(),
                )
          }
          helperText={dataError.pnombre ? validMessage.required : null}
          error={dataError.pnombre}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          size="small"
          id={CONST.snombre.name}
          label={CONST.snombre.label}
          value={data.snombre}
          disabled={userSearch}
          onChange={(e) =>
            userSearch
              ? false
              : _handleSetDataField(
                  CONST.snombre.name,
                  e.target.value.toUpperCase(),
                )
          }
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          size="small"
          id={CONST.papellido.name}
          required
          label={CONST.papellido.label}
          value={data.papellido}
          disabled={userSearch}
          onChange={(e) =>
            userSearch
              ? false
              : _handleSetDataField(
                  CONST.papellido.name,
                  e.target.value.toUpperCase(),
                )
          }
          helperText={dataError.papellido ? validMessage.required : null}
          error={dataError.papellido}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          size="small"
          id={CONST.sapellido.name}
          label={CONST.sapellido.label}
          value={data.sapellido}
          disabled={userSearch}
          onChange={(e) =>
            userSearch
              ? false
              : _handleSetDataField(
                  CONST.sapellido.name,
                  e.target.value.toUpperCase(),
                )
          }
        />
      </Grid>
      <Grid item xs={12} md={6}>
        {selectGenero}
      </Grid>
      <Grid item xs={12} md={6}>
        <FechaField
          views={['year', 'month', 'day']}
          openTo="year"
          label={CONST.fechaNacimiento.label}
          value={data.fechaNacimiento}
          error={dataError.fechaNacimiento}
          disabled={userSearch}
          botonCurrentDate={false}
          onChange={(e) =>
            userSearch
              ? false
              : _handleSetDataField(
                  CONST.fechaNacimiento.name,
                  dateformat(e, {}),
                )
          }
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          size="small"
          id={CONST.correo.name}
          required
          label={CONST.correo.label}
          value={data.correo}
          disabled={userSearch}
          onChange={(e) =>
            userSearch
              ? false
              : _handleSetDataField(CONST.correo.name, e.target.value)
          }
          helperText={dataError.correo ? validMessage.required : null}
          error={dataError.correo}
        />
      </Grid>

      {!userSearch && (
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.password.name}
            required={!activo}
            label={CONST.password.label}
            value={data.password}
            disabled={userSearch}
            onChange={(e) =>
              userSearch
                ? false
                : _handleSetDataField(CONST.password.name, e.target.value)
            }
            helperText={
              !activo && dataError.password ? validMessage.required : null
            }
            error={activo ? null : dataError.password}
          />
        </Grid>
      )}
    </Grid>
  );

  const estudiantesWidget = (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              size="small"
              id="dniEstudiante"
              label="Identificación del estudiante"
              value={textSearchEstudiante}
              onChange={async (e) => {
                const q = e.target.value;
                setTextSearchEstudiante(q);
                try {
                  if (q && q.length >= 6) {
                    clearTimeout(intervalSearch);
                    intervalSearch = setTimeout(async () => {
                      setLoadingSearch(true);
                      const res = await allEstudiantesService({
                        idEntidad: entidadesStore.activo.id,
                        q,
                        page: 1,
                      });
                      setEstudiantes(res.data.data);
                      setLoadingSearch(false);
                    }, 800);
                  }
                } catch (e) {
                  tryCatchHelper({ e, notify });
                }
              }}
            />
            {loadingSearch && <LoadingWidget isLoading={loadingSearch} />}
          </Grid>

          <Grid item xs={12} md={12}>
            {estudiantes.map((el) => {
              return (
                <CardEstudianteComponent
                  data={el}
                  onPress={() => {
                    if (!selectEstudiantes.includes(el)) {
                      setSelectEstudiantes((old) => [
                        ...old,
                        {
                          parentesco: 'MADRE',
                          estudiante: el,
                        },
                      ]);
                      setEstudiantes([]);
                      setTextSearchEstudiante('');
                    }
                  }}
                />
              );
            })}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={8}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 1 }}
        >
          <Typography
            variant="body1"
            color="initial"
            sx={{ fontWeight: 'bold' }}
          >
            Seleccionados
          </Typography>
          <Typography variant="body1" color="initial">
            Cantidad: <strong>{selectEstudiantes.length}</strong>
          </Typography>
        </Stack>
        {selectEstudiantes.map((el) => {
          return (
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" alignItems="center" sx={{ width: '45%' }}>
                <Avatar
                  alt={el.estudiante.id}
                  sx={{ width: 30, height: 30, mr: 1 }}
                  src={getFilesArchivos(el.estudiante.usuario.perfil.avatar)}
                />
                <Typography variant="sibTitle1" color="initial">
                  {el.estudiante.usuario.perfil.dni}{' '}
                  {el.estudiante.usuario.perfil.pnombre}{' '}
                  {el.estudiante.usuario.perfil.papellido}
                </Typography>
              </Stack>
              <Box sx={{ width: '25%' }}>
                <TiposParentescosField
                  value={el.parentesco}
                  isAll={false}
                  fullWidth
                  onChange={async (parentesco) => {
                    const item = selectEstudiantes.find(
                      (item) => item.estudiante.id === el.estudiante.id,
                    );
                    item.parentesco = parentesco;
                    const newArr = selectEstudiantes.filter((object) => {
                      return object.estudiante.id !== item.estudiante.id;
                    });
                    newArr.push(item);
                    setSelectEstudiantes(newArr);
                  }}
                />
              </Box>
              <BotonComponent
                icon
                closeIcon
                click={() => {
                  const l = selectEstudiantes.filter(
                    (item) => item.estudiante.id !== el.estudiante.id,
                  );
                  setSelectEstudiantes(l);
                }}
                red
              />
            </Stack>
          );
        })}
      </Grid>
    </Grid>
  );

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        {userSearch && (
          <Grid item xs={12} md={12}>
            Representante:{' '}
            <strong>
              {userSearch.perfil.tipoDni}-{userSearch.perfil.dni}{' '}
              {userSearch.perfil.pnombre} {userSearch.perfil.papellido}
            </strong>
          </Grid>
        )}
        <Grid item xs={12} md={12}>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabs} aria-label="tabs-familiares">
                <Tab label="Información del representante" value="1" />
                <Tab label="Asignar estudiantes" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" sx={{ pt: 3 }}>
              {familiarWidget}
            </TabPanel>
            <TabPanel value="2" sx={{ pt: 3 }}>
              {estudiantesWidget}
            </TabPanel>
          </TabContext>
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green
            mr={2}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormFamiliarComponent;
